import { ReactElement } from 'react'

// for type safety only
export function routeCrumb(crumb: () => ReactElement) {
  return {
    crumb,
  }
}
